import {makeReactContext} from 'lib/makeReactContext';

// The parent component (AnalysisTemplateConfig) has access to all the data needed to answer the
// question: which templates is this dataset used in?
export interface AnalysisTemplateConfigContextValue {
  usedInWhichAnalysisTemplates: (datasetId: string) => JSX.Element | null;
}

const AnalysisTemplateConfigContext = makeReactContext<AnalysisTemplateConfigContextValue>(
  () => ({
    usedInWhichAnalysisTemplates: () => null,
  }),
  'AnalysisTemplateConfigContext'
);

export default AnalysisTemplateConfigContext;
